<template lang="pug">
    #detective-wrapper.detective(v-if="user.type !== 'olympiads-student'")
        .detective-buttons-container
            .detective-icon(
                @click='isLettersShown = true',
                v-if='showLetters',
                :title="$i18n.t('detective.detective_button_lettersTitle')"
            )
                img(:src='LetterImage')
        template
            button.button.button__previous-chapter(
                :class="isButtonLoading && 'is-loading'",
                v-if="stage && stage.id === 2 && !(items.includes('eighthLetter') && !isNameUnraveled)",
                @click='previousChapter'
            )
                | {{ $i18n.t('detective.detective_conversation_previousChapter') }}
            button.button.button__previous-chapter(
                :class="isButtonLoading && 'is-loading'",
                v-if='stage && stage.id === 1 && stage.isCompleted && !isBuyNextItemAvailable',
                @click='buyNextItem'
            )
                | {{ $i18n.t('detective.detective_conversation_nextChapter') }}
        letters(
            v-if='stage && stage.id === 2',
            :display-modal='isLettersShown',
            :letters='items',
            @open='isLettersShown = true',
            @close='isLettersShown = false',
            @playDialog='playDialog'
        )
        transition(name='fade')
            conversation-modal(
                @close='closeConversationModalHandler',
                @handleDialogFinish='handleDialogFinish',
                v-if='isModalActive',
                :is-letter-set='isLetterSet',
                :chapter='chapter',
                :items='items',
                :item-name='sceneName',
                :is-introduction='isIntroduction',
                :is-first-time='isFirstTime',
                :conversation='conversation',
                :sound='sound',
                :detective-src='detectiveSrc',
                :clevik-src='clevikSrc',
                :is-mobile='isMobile',
                :replay='replay',
                :stage-id='stage && stage.id'
            )
        .static-page
            component(
                :is='chapter',
                :items='items',
                :detective-src='detectiveSrc',
                :clevik-src='clevikSrc',
                :scene-name='sceneName',
                :is-introduction='isIntroduction',
                :is-name-unraveled='isNameUnraveled',
                :is-first-time='isFirstTime',
                :is-full-screen='isFullScreen',
                :is-conversation='false',
                :is-mobile='isMobile',
                @playDialog='playDialog',
                @rightAnswer='setNameAsUnraveled'
            )
        .progress-buttons
            button.button.is-disabled.progress-button(v-if='points < nextItemPrice && stage && !stage.isCompleted')
                span.progress-bar-header
                    | {{ $i18n.t('detective.detective_conversation_left') }}
                    | {{ nextItemPrice - points }}
                    | {{ $i18n.t('detective.detective_conversation_pointsToGo') }}
                progress.progress.is-info(:value='points' :max='nextItemPrice')
                span.progress-text {{ points }} &icy;&zcy; {{ nextItemPrice }}
            button.button(
                :class="isButtonLoading && 'is-loading'",
                v-else-if='isBuyNextItemAvailable && stage && !(stage.isCompleted && stage.id === 2)',
                @click='buyNextItem'
            )
                | {{ nextItem ? $i18n.t('detective.detective_conversation_getNextItem') : $i18n.t('detective.detective_conversation_nextChapter') }}
</template>

<script>
    import { mapState } from 'vuex';
    const ConversationModal = () => import('../../../modals/detective/Conversation.vue');
    import DetectiveProgress from './Progress.vue';
    import MobileDetect from 'mobile-detect/mobile-detect.js';
    import motivationApi from '../../../api/motivation/motivationApi.js';
    const Chapter_1 = () => import('./chapters/Chapter_1.vue');
    const Chapter_2 = () => import('./chapters/Chapter_2.vue');
    import Letters from './Letters.vue';

    import LetterImage from '../../../assets/images/detective/chapter_2/letters/first.png';

    const MOTIVATION_TYPE = 'detective';
    const INTRODUCTION_SCENE = 'Introduction';

    export default {
        props: ['modal'],
        mounted() {
            this.isMobile = Boolean(new MobileDetect(window.navigator.userAgent).phone());
            if (window.innerWidth > window.innerHeight && this.isMobile) {
                this.isFullScreen = true;
                document.getElementsByClassName('sidebar-column')[0].classList.toggle('is-hidden');
                document.getElementsByClassName('app-header')[0].classList.toggle('is-hidden');
            }
            this.fetchData();
        },
        data() {
            return {
                isModalActive: false,
                isFirstTime: false,
                isFullScreen: false,
                isMobile: false,
                isButtonLoading: false,
                sceneId: 0,
                sceneName: '',
                stages: null,
                points: 0,
                stage: null,
                data: null,
                nextItemPrice: 0,
                nextItem: null,
                item: null,
                scenes: [],
                conversation: [],
                items: [],
                sound: null,
                isIntroduction: true,
                chapter: '',
                replay: false,
                isLettersShown: false,
                isNameUnraveled: false,
                LetterImage,
                isLetterSet: true,
            };
        },
        watch: {
            isFullScreen(val) {
                let mainColumnClassList = document.getElementsByClassName('main-column')[0].classList;
                let appContainerBodyClassList = document.querySelector('.app-container__body').classList;
                if (val) {
                    mainColumnClassList.add('is-fullscreen');
                    appContainerBodyClassList.add('is-fullscreen');
                } else {
                    mainColumnClassList.remove('is-fullscreen');
                    appContainerBodyClassList.remove('is-fullscreen');
                }
            },
            isModalActive(value) {
                if (value) {
                    document.getElementsByTagName('html')[0].style.cssText = 'overflow: hidden';
                } else {
                    document.getElementsByTagName('html')[0].style.cssText = 'overflow: auto';
                }
            },
        },
        methods: {
            fetchData() {
                motivationApi
                    .show(this.user.id, MOTIVATION_TYPE)
                    .then(motivation => {
                        this.setData(motivation);
                    })
                    .catch(e => this.showErrorMessage(e));
            },
            completeStage() {
                if (!this.stage.isCompleted) {
                    this.stage.isCompleted = true;
                    this.updateData();
                } else if (this.stage.id !== 3) {
                    this.stage = this.stages.find(stage => stage.id === this.stage.id + 1);
                    this.setStageData();
                }
                this.isButtonLoading = false;
            },
            updateData(points = undefined) {
                this.isButtonLoading = true;
                motivationApi
                    .update(this.user.id, { type: MOTIVATION_TYPE, data: JSON.stringify(this.data), points: points })
                    .then(motivation => {
                        if (!this.isIntroduction) {
                            this.setData(motivation);
                        }
                        this.isButtonLoading = false;
                    })
                    .catch(e => this.showErrorMessage(e));
            },
            setStageData() {
                this.chapter = 'chapter_' + this.stage.id;
                this.isIntroduction = _.cloneDeep(this.stage.isIntroduction);
                if (this.stage.id === 2) {
                    this.isNameUnraveled = this.stage.isNameUnraveled;
                }
                this.items = this.stage.items.filter(item => item.isBought).map(item => item.name);
                this.scenes = this.$i18n.t(`detectiveStoryConversations.${this.stage.id}`);
                this.sceneId = this.stage.scene;
                this.sceneName = this.scenes[this.sceneId].name;
                this.conversation = this.scenes[this.sceneId].conversation;
                this.sound = this.scenes[this.sceneId].sound;
                this.item = this.stage.items.find(item => item.id === this.sceneId);
                this.nextItem = this.stage.items.find(item => item.id === this.sceneId + 1);
                this.nextItemPrice = this.nextItem ? this.nextItem.price : 500;
                if (this.isIntroduction || (this.item && !this.item.isBought)) {
                    this.$nextTick(this.openModal);
                }
            },
            setData(motivation) {
                this.data = JSON.parse(motivation.data);
                this.points = this.data.points;
                this.stages = this.data.stages;
                for(let stage of this.stages) {
                  let item = stage.items.find(item => !item.isBought);
                  if (item) {
                    let id = stage.id - 1;
                    if(item.id < this.stages[id].scene) {
                      this.stages[id].isCompleted = false;
                      this.stages[id].scene = item.id > 0 ? item.id - 1 : 0;
                      break;
                    }
                  }
                }
                this.stage = this.stages.find(stage => {
                    if (!stage.isCompleted && stage.id !== 3) {
                        return stage;
                    }
                    return stage.id === 2 && stage;
                });
                //TODO: delete this if, when all stages will be written
                if (this.stage.id === 3) {
                    return;
                }
                this.setStageData();
            },
            previousChapter() {
                if (this.stage.id !== 1) {
                    this.stage = this.stages.find(stage => stage.id === this.stage.id - 1);
                    this.setStageData();
                }
            },
            showErrorMessage(err) {
                if (err.data) {
                    this.$toasted.error(this.$root.$t(`errors.${err.data.message}`));
                    this.$router.push({ name: 'dashboard' });
                }
                err = err.response && err.response.data ? err.response.data : err;
                if (err && (err.status_code === 403 || err.status_code === 404)) {
                    this.$router.push({ name: 'dashboard' });
                    this.$toasted.error(err.message);
                }
            },
            closeConversationModalHandler() {
                this.isModalActive = false;
                if (this.isIntroduction) {
                    this.stage.isIntroduction = false;
                    this.updateData();
                }
                this.isFirstTime = false;
                this.sceneName = this.scenes[this.sceneId].name;
            },
            setItemAsBought() {
                this.item.isBought = true;
                this.updateData();
                this.isLetterSet = true;
            },
            setNameAsUnraveled() {
                this.data.stages[1].isNameUnraveled = true;
                this.updateData();
            },
            openModal() {
                if (!this.isModalActive) {
                    this.isFirstTime = !this.items.includes(this.sceneName);
                }
                this.isModalActive = true;
            },
            buyNextItem() {
                if (this.isButtonLoading) {
                    return;
                }
                this.isModalActive = false;
                this.isButtonLoading = true;
                if (this.sceneId === this.scenes.length - 1 || this.stage.isCompleted) {
                    this.completeStage();
                    return;
                }
                this.stage.scene++;
                if (this.isIntroduction) {
                    this.isIntroduction = false;
                }
                let currentItem = this.stage.items.find(item => item.id === this.stage.scene);
                if(currentItem.isBought) {
                    let nextAvailableItem = this.stage.items.find(item => item.isBought === false)
                    this.stage.scene = nextAvailableItem.id;
                }
                this.updateData(-this.nextItem.price);
            },
            playDialog(sceneName) {
                this.isFirstTime = false;
                let scene = this.scenes.find(scene => scene.name === sceneName);
                this.sceneName = sceneName;
                this.conversation = scene.conversation;
                this.sound = scene.sound;
                this.replay = true;
                this.$nextTick(this.openModal);
            },
            handleDialogFinish() {
                this.isFirstTime = false;
                this.isLetterSet = false;
                if (this.item && !this.item.isBought) {
                    this.setItemAsBought();
                }
            },
            isSkipThingOrWord (id, item) {
                return item.id < this.stages[id].scene || (item.id - this.stages[id].scene) > 1;
            },
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            detectiveSrc() {
                const imageName =
                    this.sceneName === INTRODUCTION_SCENE ? 'detective_with_closed_bag.png' : 'detective.png';
                return require(`../../../assets/images/detective/chapter_1/right_interlocutor/${imageName}`);
            },
            clevikSrc() {
                const imageName = this.sceneName === INTRODUCTION_SCENE ? 'clevik_with_hand.png' : 'clevik.png';
                return require(`../../../assets/images/detective/chapter_1/left_interlocutor/${imageName}`);
            },
            showLetters() {
                return this.stage && this.stage.id > 1 && this.items.includes('firstLetter');
            },
            isBuyNextItemAvailable() {
                return (
                    this.points >= this.nextItemPrice &&
                    (this.sceneName !== 'eighthLetter' || this.isNameUnraveled) &&
                    this.stage &&
                    !this.stage.isCompleted
                );
            },
        },
        components: {
            Letters,
            Chapter_1,
            Chapter_2,
            ConversationModal,
            DetectiveProgress,
        },
    };
</script>

<style scoped lang="scss">
    @import '@/assets/sass/detective/modals.scss';
    @import '@/assets/sass/detective/progress.scss';
    @import '@/assets/sass/detective/index.scss';

    $color-white: rgb(255, 255, 255);
    $color-green-500: rgb(142, 193, 98);
    $gray-dark: #4a4a4a;
    $progress-bar-green: #6bbe68;
    $progress-bar-copper: #ff9a5a;

    .modal {
        transition: all 0.3s;
        opacity: 1;
    }
    .fade-enter-active,
    .fade-leave-active {
        opacity: 0;
    }

    .static-page {
        display: flex;
        justify-content: center;
        height: 100%;
    }
    .button {
        cursor: pointer;
        padding: 0.5rem 0.75rem;
        &:active,
        &:focus {
            outline: none;
        }
    }
    .button__previous-chapter {
        border: none;
        cursor: pointer;
        border-radius: 12px;
        font-size: 20px;
        font-weight: 500;
        color: #ffffff;
        position: absolute;
        top: 0;
        right: 0;
        z-index: 1;
        margin: 1.4rem;
        padding: 0.5rem 0.75rem;
        background: lighten($color-green-500, 10%);
        &:active,
        &:focus {
            outline: none;
        }
    }

    .progress-buttons {
        width: 100%;
        position: absolute;
        bottom: 1rem;
        display: flex;
        justify-content: center;
        background-color: rgba(0, 0, 0, 0);
        border-top: none;
        align-self: center;
        margin-bottom: 12px;
        .button {
            background: lighten($color-green-500, 10%);
            border: none;
            border-radius: 12px;
            font-size: 20px;
            font-weight: 500;
            color: $x-color-white;
            &__previous-chapter {
                position: absolute;
                top: 0;
                right: 0;
                z-index: 1;
                margin: 1.4rem;
                background: lighten($color-green-500, 10%);
            }
            .progress-bar-header {
                font-weight: 600;
            }
            &:hover {
                background: $color-green-500;
            }
            &.progress-button {
                display: flex;
                flex-direction: column;
                height: auto;
                align-items: center;
                padding: 15px 30px;
                &:active,
                &:focus {
                    outline: none;
                }
                .progress-text {
                    position: absolute;
                    color: #ffffff;
                    bottom: 10px;
                    margin-bottom: 8px;
                    font-size: 0.9rem;
                    @media screen and (max-width: 850px) {
                        bottom: 0.6rem;
                        font-size: 0.75rem;
                    }
                }
                .progress {
                    height: 1.2rem;
                    border-radius: 5px;
                    margin-top: 5px;
                    margin-bottom: 0;
                    width: 100%;
                    &::-webkit-progress-value {
                        background: $progress-bar-copper;
                    }
                    &::-moz-progress-bar {
                        background: $progress-bar-copper;
                    }
                    &::-webkit-progress-bar {
                        background-color: $progress-bar-green;
                    }
                }
                &.is-disabled {
                    opacity: 1;
                    background-color: $x-color-white;
                    color: $gray-dark;
                }
            }
            @media screen and (max-width: 850px) {
                font-size: 14px;
            }
        }
    }
</style>
